function setCountdownValues(datesArray) {
    // variables for time units
    var days, hours, minutes, seconds;
    for (var i = 0; i < datesArray.length; i++) {
        var dateElem = datesArray[i].elem,
            counter = datesArray[i].counter,
            target_date = datesArray[i].date;
            // find the amount of "seconds" between now and target
            var current_date = new Date().getTime(),
                seconds_left = (target_date - current_date) / 1000,
                isToday = target_date <= current_date;
            
            $(counter).fadeIn();
        
            if (isToday) {
                $(counter).text('Event started!');
                $(counter).addClass('event-ongoing');
                $('.countdown-button').remove();
                continue;
            } else {
                 // do some time calculations
                days = parseInt(seconds_left / 86400);
                seconds_left = seconds_left % 86400;
            
                hours = parseInt(seconds_left / 3600);
                seconds_left = seconds_left % 3600;
            
                minutes = parseInt(seconds_left / 60);
                seconds = parseInt(seconds_left % 60);
            
                // format countdown string + set tag value
                $(counter).find('.days').text(days);
                $(counter).find('.hours').text(hours);
                $(counter).find('.minutes').text(minutes);
                $(counter).find('.seconds').text(seconds);
            }
    }
}

function countdownClock() {

    var datesArray = [];

	$('.counter').hide();
    $('.countdown-end-date').hide();


    $('.countdown-end-date').each(function () {
        var self = $(this),
            eventCounter = $(self).find('+ .counter'),
            eventDate = new Date ($(self).find('.HtmlContent').text()).getTime();

        var obj = {
            elem: self,
            date: eventDate,
            counter: eventCounter
        }

        datesArray.push(obj);
    });
    
    setCountdownValues(datesArray);

    // update the tag with class "countdown" every 1 minute
    setInterval(function() {
        setCountdownValues(datesArray);
       
    }, 1000);

}

$(function () {
    if (!!($('.countdown-button').html()) ||
        !!($('.counter').html())) {
            countdownClock();
        }
});